// extracted by mini-css-extract-plugin
export default {"modal":"CompanyAssociation_modal__z9kaI","modalTitle":"CompanyAssociation_modalTitle__inTAK","titleSubText":"CompanyAssociation_titleSubText__0w7VO"};